/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IpAllowlistEntryResource } from '../models/IpAllowlistEntryResource'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class IpAllowlistService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Search the IP allowlist.
     * @returns any OK
     * @throws ApiError
     */
    public getIpAllowlist({
        page,
        search
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
        /**
         * Filter by a substring of the IP address
         */
        search?: string
    }): CancelablePromise<{
        data: Array<IpAllowlistEntryResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ip-allowlist',
            query: {
                page: page,
                search: search
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Add an IP to the allowlist.
     * @returns void
     * @throws ApiError
     */
    public createIpAllowlistEntry({
        requestBody
    }: {
        requestBody: {
            ip: string
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ip-allowlist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Remove an IP from the allowlist.
     * @returns void
     * @throws ApiError
     */
    public deleteIpAllowlistEntry({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/ip-allowlist/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
